<div class="custom-overlay">
  </div>
